import React, { useEffect, useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ChartDataLabels);
ChartJS.register(ArcElement, Tooltip, Legend);

const GraficoEquipamiento = ({ grafico_data }) => {

   const [chartData, setCharData] = useState(grafico_data);

   useEffect(() => {
      setCharData(grafico_data);
   }, [grafico_data])

   var options = {
      responsive: true,
      aspectRatio: 4 / 2,
      layout: {
         padding: 20
      },
      plugins: {
         legend: {
            display: true,
            align: 'center',
            position: 'left',
            title: {
               display: true,
               text: 'ESTADO',
               position: 'center'
            }
         },
         datalabels: {
            display: true,
            color: '#FFF',
            anchor: 'end',
            borderColor: 'white',
            borderRadius: 25,
            borderWidth: 2,
            color: 'white',
            backgroundColor: function (context) {
               return context.dataset.backgroundColor;
            },
            font: {
               weight: 'bold'
            }
         }
      },
   };

   var data = {
      labels: [
         'Bueno',
         'Regular',
         'Malo P. Reparar',
         'Malo P. Baja',
         'Inop. P. Reparar',
         'Inop. P. Baja',
      ],
      datasets: [
         {
            data: chartData,
            backgroundColor: [
               '#3c8dbc',
               '#00a65a',
               '#f39c12',
               '#00c0ef',
               '#d2d6de',
               '#f56954'
            ]
         },
      ],
   };

   return (
      <Doughnut data={data} options={options} />
   );
};

export default GraficoEquipamiento;
